import { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Button } from '@/components/ui/Button';
import { Cookie } from 'lucide-react';

export function CookieConsent() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookie-consent');
    if (!consent) {
      setIsVisible(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookie-consent', 'accepted');
    localStorage.setItem('cookie-consent-date', new Date().toISOString());
    setIsVisible(false);
  };

  const handleReject = () => {
    localStorage.setItem('cookie-consent', 'rejected');
    localStorage.setItem('cookie-consent-date', new Date().toISOString());
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <AnimatePresence>
      <motion.div
        initial={{ y: 100, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        exit={{ y: 100, opacity: 0 }}
        className="fixed bottom-0 left-0 right-0 z-50 p-4"
      >
        <div className="max-w-4xl mx-auto bg-gray-900/95 backdrop-blur-lg border border-white/10 rounded-2xl p-6 shadow-2xl">
          <div className="flex flex-col md:flex-row items-start md:items-center gap-4">
            <div className="flex-shrink-0 w-12 h-12 rounded-full bg-orange-500/10 flex items-center justify-center">
              <Cookie className="w-6 h-6 text-orange-500" />
            </div>
            
            <div className="flex-1">
              <h3 className="text-white font-semibold mb-1">
                Utilizamos cookies
              </h3>
              <p className="text-gray-400 text-sm leading-relaxed">
                Usamos cookies para melhorar sua experiência, personalizar conteúdo e anúncios, 
                e analisar nosso tráfego. Ao clicar em "Aceitar", você concorda com o uso de 
                cookies conforme nossa{' '}
                <a href="/politica-de-privacidade" className="text-orange-400 hover:underline">
                  Política de Privacidade
                </a>{' '}
                e{' '}
                <a href="/politica-de-cookies" className="text-orange-400 hover:underline">
                  Política de Cookies
                </a>.
              </p>
            </div>

            <div className="flex flex-col sm:flex-row gap-2 w-full md:w-auto">
              <Button
                variant="outline"
                size="sm"
                onClick={handleReject}
                className="border-white/30 text-white bg-white/10 hover:bg-white/20 hover:text-white"
              >
                Recusar
              </Button>
              <Button
                variant="nuvem"
                size="sm"
                onClick={handleAccept}
              >
                Aceitar
              </Button>
            </div>
          </div>
        </div>
      </motion.div>
    </AnimatePresence>
  );
}
